export const MM = 'MM';
export const PCPP = 'PCPP';
export const greenColor = 'green';
export const whiteColor = 'white';
